module.exports = __webpack_public_path__ + "static/media/img4.98eb5ebc.svg";